import { createContext } from "react";
import { userInterface } from "../../interfaces/userInterface";

export type AuthContextType = {
    user: userInterface | null
    loading: boolean // <--- ADICIONE ESTA LINHA
    signin: (email:string, password:string) => Promise<boolean>
    signout: () => void
    logged: () => Promise<boolean>
    theme: string
    toggleTheme: (theme:string) => void
    storeBook: (form:object) => any
    lastRoute: string
    setLastRoute: (route:string) => void
    setUser: (user: userInterface) => void // Ajustado para receber o tipo certo
}

export const AuthContext = createContext<AuthContextType>(null!)